import React from "react";
import PhoneInput from "react-phone-input-2";

interface Props {
  value?: string;
  disabled: boolean;
  onChange: (value: string, country: { dialCode: string }) => void;
}

const PhoneNumberInput = (props: Props) => {
  return (
    <div className="PhoneNumberContainer">
      <h2 className="PhoneNumberTitle">Phone number</h2>
      <PhoneInput
        value={props.value}
        onChange={props.onChange}
        disabled={props.disabled}
        enableLongNumbers={true}
        enableSearch={true}
        disableSearchIcon={true}
      />
    </div>
  );
};

export default PhoneNumberInput;